// import React, { useEffect, useState } from 'react';
// import {
//   Card,
//   Row,
//   CardTitle,
//   CardBody,
//   Button,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
// } from 'reactstrap';
// import { useNavigate, useLocation } from 'react-router-dom';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';
// import useVendorBranch from '../../utils/useVendorBranch';

// const AddEditHoliday = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useSelector((state) => state.authState);

//   const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

//   const [holidayData, setHolidayData] = useState({
//     id: 0,
//     vendor_id: 0,
//     branch_id: 0,
//     holiday_date: '',
//     holiday_name: '',
//     holiday_type: '',
//     applicable_for: '',
//     is_active: true,
//   });

//   const [errorMessage, setErrorMessage] = useState({});

//   useEffect(() => {
//     if (location.state) {
//       setHolidayData(location.state);
//     }
//   }, [location.state]);

//   const onChangeHandle = (e) => {
//     const { name, value } = e.target;
//     setHolidayData((prev) => ({ ...prev, [name]: value }));
//     setErrorMessage((prev) => ({ ...prev, [name]: '' }));
//   };

//   const validate = () => {
//     if (isSuperAdmin && !holidayData.vendor_id) {
//       toast.error('Please select vendor');
//       return false;
//     }
//     if ((isSuperAdmin || isAdmin || hasMultiBranch) && !holidayData.branch_id) {
//       toast.error('Please select branch');
//       return false;
//     }
//     if (!holidayData.holiday_name) {
//       setErrorMessage((prev) => ({
//         ...prev,
//         holiday_name: 'Holiday name required',
//       }));
//       return false;
//     }
//     if (!holidayData.holiday_date) {
//       setErrorMessage((prev) => ({
//         ...prev,
//         holiday_date: 'Holiday date required',
//       }));
//       return false;
//     }
//     return true;
//   };

//   const SaveHoliday = async () => {
//     if (!validate()) return;

//     try {
//       let response;
//       if (holidayData.id && holidayData.id > 0) {
//         response = await apiService.put(
//           `api/HolidayMaster/UpdateHoliday?id=${holidayData.id}`,
//           holidayData,
//         );
//       } else {
//         response = await apiService.post(
//           'api/HolidayMaster/AddHoliday',
//           holidayData,
//         );
//       }

//       if (response.status === true) {
//         toast.success(response.message);
//         navigate('/list-holiday');
//       } else {
//         toast.error(response.message);
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong');
//     }
//   };

//   const DeleteHoliday = async () => {
//     if (!window.confirm('Delete this holiday?')) return;

//     try {
//       const res = await apiService.delete(
//         `api/HolidayMaster/DeleteHoliday?id=${holidayData.id}`,
//       );

//       if (res.status) {
//         toast.success(res.message);
//         navigate('/list-holiday');
//       } else {
//         toast.error(res.message || 'Delete failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong');
//     }
//   };

//   return (
//     <>
//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 d-flex justify-content-between'>
//           <span>Holiday Form</span>
//           <div>
//             <Button color='warning' onClick={() => navigate(-1)}>
//               <i className='bi bi-arrow-left' />
//             </Button>
//             {holidayData.id > 0 && (
//               <Button color='danger' className='ml-2' onClick={DeleteHoliday}>
//                 <i className='bi bi-trash' />
//               </Button>
//             )}
//           </div>
//         </CardTitle>

//         <CardBody>
//           <VendorBranchSelector
//             user={user}
//             selectionData={holidayData}
//             setSelectionData={setHolidayData}
//             accessButton={true}
//             errorMessage={errorMessage}
//           />

//           <Row className='mt-3'>
//             <FormGroup className='col-sm-6'>
//               <Label>Holiday Date</Label>
//               <Input
//                 type='date'
//                 name='holiday_date'
//                 value={holidayData.holiday_date}
//                 onChange={onChangeHandle}
//               />
//               <FormText color='danger'>{errorMessage.holiday_date}</FormText>
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Holiday Name</Label>
//               <Input
//                 name='holiday_name'
//                 value={holidayData.holiday_name}
//                 onChange={onChangeHandle}
//               />
//               <FormText color='danger'>{errorMessage.holiday_name}</FormText>
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Holiday Type</Label>
//               <Input
//                 name='holiday_type'
//                 value={holidayData.holiday_type}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Applicable For</Label>
//               <Input
//                 name='applicable_for'
//                 value={holidayData.applicable_for}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>
//           </Row>

//           <Button color='primary' className='float-end' onClick={SaveHoliday}>
//             Save
//           </Button>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AddEditHoliday;
//heena
import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditHoliday = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [holidayData, setHolidayData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    holiday_date: '',
    holiday_name: '',
    holiday_type: '',
    applicable_for: '',
    is_active: true,
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (location.state) {
      setHolidayData((prev) => ({
        ...prev,
        ...location.state,
      }));
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setHolidayData((prev) => ({ ...prev, [name]: value }));
    setErrorMessage((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    if (isSuperAdmin && !holidayData.vendor_id) {
      toast.error('Please select vendor');
      return false;
    }

    if ((isSuperAdmin || isAdmin || hasMultiBranch) && !holidayData.branch_id) {
      toast.error('Please select branch');
      return false;
    }

    if (!holidayData.holiday_name) {
      setErrorMessage((prev) => ({
        ...prev,
        holiday_name: 'Holiday name required',
      }));
      return false;
    }

    if (!holidayData.holiday_date) {
      setErrorMessage((prev) => ({
        ...prev,
        holiday_date: 'Holiday date required',
      }));
      return false;
    }

    return true;
  };

  const SaveHoliday = async () => {
    if (!validate()) return;

    try {
      let response;

      if (holidayData.id && holidayData.id > 0) {
        response = await apiService.put(
          `api/HolidayMaster/UpdateHoliday?id=${holidayData.id}`,
          holidayData,
        );
      } else {
        response = await apiService.post(
          'api/HolidayMaster/AddHoliday',
          holidayData,
        );
      }

      if (response?.status === true) {
        toast.success(response?.message);
        navigate('/list-holiday');
      } else {
        toast.error(response?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  const DeleteHoliday = async () => {
    if (!window.confirm('Delete this holiday?')) return;

    try {
      const res = await apiService.delete(
        `api/HolidayMaster/DeleteHoliday?id=${holidayData.id}`,
      );

      if (res?.status) {
        toast.success(res?.message);
        navigate('/list-holiday');
      } else {
        toast.error(res?.message || 'Delete failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={holidayData}
        setSelectionData={setHolidayData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Holiday Form</span>

          <div>
            <Button color='warning' onClick={() => navigate(-1)}>
              <i className='bi bi-arrow-left' />
            </Button>

            {holidayData.id > 0 && (
              <Button color='danger' className='ml-2' onClick={DeleteHoliday}>
                <i className='bi bi-trash' />
              </Button>
            )}
          </div>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Holiday Date</Label>
              <Input
                type='date'
                name='holiday_date'
                value={holidayData.holiday_date || ''}
                onChange={onChangeHandle}
              />
              <FormText color='danger'>{errorMessage.holiday_date}</FormText>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Holiday Name</Label>
              <Input
                name='holiday_name'
                value={holidayData.holiday_name || ''}
                onChange={onChangeHandle}
              />
              <FormText color='danger'>{errorMessage.holiday_name}</FormText>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Holiday Type</Label>
              <Input
                name='holiday_type'
                value={holidayData.holiday_type || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Applicable For</Label>
              <Input
                name='applicable_for'
                value={holidayData.applicable_for || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>
          </Row>

          <Button
            color='primary'
            className='float-end mt-3'
            onClick={SaveHoliday}
          >
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditHoliday;
